module.exports = __webpack_public_path__ + "img/logo_mahjoub.7552b1b9.png";